export const mos = '!mos';
export const mosShare = '!mos-share';
